import React from 'react';
import SkeletonElement from '../../SkeletonElement';

const SkeletonMyRewardPoints = () => {
    return (
        <div className="flex flex-col shadow-xl px-4 py-6 w-full h-[150px] lg:w-full lg:h-[100px] ">
            <div className="flex flex-col lg:flex-row">
                <div className="flex flex-col lg:px-4 flex-grow">
                    <div className="">
                        <SkeletonElement type="title" />
                        <div className="mt-2">
                            <SkeletonElement type="title" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SkeletonMyRewardPoints;
